import { useNavigate } from 'react-router'

import { Client } from '../../models/Client'
import { RecordFactory } from '../../models/RecordFactory'
import { User } from '../../models/User'
import { RecordNotFoundError } from '../../models/errors/RecordNotFoundError'
import { ComponentData } from '../../utils/typing'
import { PocketComponent, PocketComponentProps, usePSComponent } from '../PocketComponent'
import { NewUserPage } from './NewUserPage'

const viewWillAppear = async ({
    urlParams,
    props: { action },
}: PocketComponent<{ action: 'new' | 'edit' }>) => {
    const [defaultClient, defaultUser] = await (async (): Promise<[Client | null, User | null]> => {
        switch (action) {
            case 'new': {
                return [new Client(), new User({ allow_trigger: true })]
            }
            case 'edit': {
                if (!urlParams.id) {
                    return [null, null]
                }
                const client = (await RecordFactory.getInstance().loadClient(urlParams.id)) ?? null
                if (!client) {
                    return [null, null]
                }
                return [client, client.person ?? null]
            }
        }
    })()
    if (defaultClient === null || defaultUser === null) {
        return new RecordNotFoundError()
    }

    return { defaultClient, defaultUser }
}

const render = ({
    data,
    base: { me, owner },
}: PocketComponentProps<ComponentData<typeof viewWillAppear>>) => {
    if (data instanceof RecordNotFoundError) {
        throw data
    }

    const navigate = useNavigate()

    const { defaultClient, defaultUser } = data

    return (
        <NewUserPage
            defaultClient={defaultClient}
            defaultUser={defaultUser}
            me={me}
            owner={owner}
            onComplete={(user) => navigate(`/clients/${user.id}`)}
            onClose={{
                action: 'go-back',
                excludePathname: /^\/clients\/new$/,
                defaultPathname: '/clients',
            }}
        />
    )
}

export const UserWorkflow = usePSComponent(render, viewWillAppear)
